import api, { getAuthParams } from './client';

export const getAnalyticsStats = (params) =>
  api.get('/analytics/stats', { params: { ...getAuthParams(), ...params } });

export const getAnalyticsReportTypes = () =>
  api.get('/analytics/report-types');

export const getCompetitiveIntelligenceReport = (params) =>
  api.get('/analytics/reports/competitive-intelligence', {
    params: { ...getAuthParams(), ...params },
  });
